import appGlobalScript from '/Users/johanneseriksson/code/webcomet-components/src/globals/global.ts';
export const globalScripts = appGlobalScript;
